import { Component, OnInit } from '@angular/core';
import { SharedService } from './../../shared/shared.service';
import { AgencyList } from '../../shared/agency.model';

@Component({
  selector: 'app-agency-list',
  templateUrl: './agency-list.component.html',
  styleUrls: ['./agency-list.component.css']
})
export class AgencyListComponent implements OnInit {
  isDesktopView: boolean;
  showCard: object = {};
  public agencyList: Array<AgencyList>;
  public totalItems: number;
  public currentPage: number = 1;
  public itemsPerPage: number = 5;
  public maxSize: number = 3;
  public listedItems: Array<AgencyList>;
  public filteredItems: Array<AgencyList>;
  public finalItems: Array<AgencyList>;
  public selItemsPerpage: number = 5;
  public activityStatusFlag: string = "All";
  constructor(
    private sharedService: SharedService) {
    this.isDesktopView = this.sharedService.getDeviceType();
  }

  ngOnInit() {
    this.sharedService.getAgencyList('list')
      .subscribe((response) => {
        this.agencyList = response;
        this.totalItems = this.agencyList.length;
        this.buildPageContents(this.currentPage);
        this.sharedService.authenticateUser('', '').subscribe((response) => {
        });
      });
     
  }

  openCard(agent) {
    Object.keys(this.showCard).forEach(h => {
      this.showCard[h] = false;
    });
    this.showCard[agent.iatacode] = true;
  }

  searchFilter(value: string, event) {
    if (!value) {
      this.filteredItems = [];
      this.totalItems = this.agencyList.length;
      this.currentPage = 1;
      this.buildPageContents(this.currentPage);
    }
    else {
      if (this.agencyList.filter(item =>
        (
          (item['agencyName'].toUpperCase().indexOf(value.toUpperCase()) !== -1) ||
          (item['iatacode'].toUpperCase().indexOf(value.toUpperCase()) !== -1)
        ))
      ) {
        this.filteredItems = this.agencyList.filter(item =>
          (
            (item['agencyName'].toUpperCase().indexOf(value.toUpperCase()) !== -1) ||
            (item['iatacode'].toUpperCase().indexOf(value.toUpperCase()) !== -1)
          )
        );
        
        if(this.filteredItems.length==0){
          this.listedItems.length=0;
          this.totalItems = this.filteredItems.length;
        }
        else{
          this.totalItems = this.filteredItems.length;
          this.currentPage = 1;
          this.buildPageContents(this.currentPage);
          return this.agencyList.filter(item =>
            (
              (item['agencyName'].toUpperCase().indexOf(value.toUpperCase()) !== -1) ||
              (item['iatacode'].toUpperCase().indexOf(value.toUpperCase()) !== -1)
            )
          );
        }
        
      }
    }
  }

  public pageChanged(event: any): void {
    this.buildPageContents(event.page);
  }

  public activityFlagChanged(flag, itemList) {

    if (flag == "Active") {
      return itemList.filter(item =>
        (
          (item['travelAgentStatus'].indexOf("1") !== -1)
        )
      );
    }
    else if (flag == "Inactive") {
      return itemList.filter(item =>
        (
          (item['travelAgentStatus'].indexOf("0") !== -1)
        )
      );
    }
    else {
      return itemList;
    }
  }

  public activityClick() {
    this.buildPageContents(this.currentPage);
  }

  public buildPageContents(currentPage) {
    let newArray = [];
    let startItem = (currentPage - 1) * this.itemsPerPage;
    if (startItem < 1) startItem = 0;
    let endItem = this.itemsPerPage;
    if (endItem < 1) endItem = this.totalItems;

    for (let i = 0; i < endItem; i++) {
      if (this.filteredItems && this.filteredItems.length > 0) {
        this.finalItems = this.activityFlagChanged(this.activityStatusFlag, this.filteredItems);
      }
      else {
        this.finalItems = this.activityFlagChanged(this.activityStatusFlag, this.agencyList);
      }
    }
    this.totalItems = this.finalItems.length;
    for (let i = 0; i < endItem; i++) {
      if (this.filteredItems && this.filteredItems.length > 0) {
        if (this.totalItems > 0 && this.finalItems[startItem + i]) {
          newArray.push(this.finalItems[startItem + i])
        }
      } else if (this.filteredItems && this.totalItems === 0) {
        newArray = [];
      }
      else {
        if (this.finalItems[startItem + i])
          newArray.push(this.finalItems[startItem + i])
      }
    }

    this.listedItems = newArray;  
  }

  public onChangeEvent(evnet: any): void {
    this.itemsPerPage = this.selItemsPerpage;
    this.buildPageContents(this.currentPage);
  }
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/dashboard/agency-list/agency-list.component.ts